import { Link } from "react-router-dom"

const akatistText = `

Кондак 1:

Изабрани Исповедници Христови, украс наше Цркве, они који су трпели муке и поруге у тамници, истински војници Господњи који силом Крста посрамљују слуге сатане и моле се за нас на небесима, са жељом да их хвалимо говорећи:
Радујте се, Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Икос 1: 


Са иконе и са олтара сте кренули, Свети исповедници, да браните праву веру и румунски народ од пошасти која је долазила са истока, и ни прогон ни тамница вас нису уплашили, него сте чврсто стали против лукавства сатаниних, за које вас, радујући се, хвалимо, говорећи величамо: 
Радујте се, крин пречисте душе.
Радујте се, јер вас никаква мука не оскрнави.
Радујте се, јер сте хтели да разбијете ропство нације.
Радујте се, јер сте крвљу земљу земљи основали.
Радујте се, јер су вас непријатељи Христови прогонили.
Радујте се, јер вас удараше издајице народа.
Радујте се, јер сте сатрвени поново Васкрсли.
Радујте се, јер вам је помисао на мртве дала снагу.
Радујте се, јер је живот ваш био молитва и плач.
Радујте се, јер сте принели жртву паљеницу.
Радујте се, јер вас је дар Архангела засенио.
Радујте се, јер сте силом Крста Часног победили.
Радујте се, Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 2:

Црвена звер (комунизам) са гневом крену на Цркву Христову, и сав свет се згрози од страшних безакоња: да су иконе погажене, мошти светих 
исмејане, свештеници побијени, и многе цркве порушене; а ви, Светитељи, не желећи да нам оставите земљу без олтара и крстова, храбро се одупресте нечастивима, певајући Богу: Алилуја!

Икос 2:

Хришћанско насеље света се колебало и силе страшне таме пениле су се, а војници Христови храброг срца, не трпећи тако нешто, похиташе у крваву Шпанију где с радошћу примише мучеништво; а ви светитељи сте на гробу своме завет водили у добру борбу за спас народа, за шта са захвалношћу кажемо:
Радујте се , браниоци румунског народа.
Радујте се , достојни синови земље прадедовске.
Радујте се , јер вам два младића дадоше живи пример.
Радујте се , јер сте срећни отишли у смрт.
Радујте се , јер сте на гробу њиховом завет рекли.
Радујте се , јер сте у сиромаштву обећали да ћете живети.
Радујте се , јер сте се земаљских радости одрекао.
Радујте се , јер сте се обавезали да служите земљи.
Радујте се , јер сте планине страдања прешли.
Радујте се , јер већина вас није имала младост.
Радујте се , јер се кроз вас народ испунио.
Радујте се , јер је ваш бол стоструко родио.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа 

узашли!

Кондак 3:

Непријатељи Крста и издајници земље хтели су да отргну душу Румунску од Христа, али устаде храбри бранилац са душом Архангела, који живот свој положи за прадедовски закон, говорећи: „ Онај ко се бори, макар и сам, за Бога и свој народ, неће бити побеђен никада“ ; и сада, победоносно, са анђелима на небу, мученичким смрћу овенчали сте се певајући Богу непрестано: Алилуја!

3. Икос:

Убојити тиранин и злочеста Јеврејка, не могавши да виде ваше чисте душе како горе љубављу према вери и народу, 
дадоше ђавоље наређење да вас ноћу одведу у шуму и задаве, па изрешетају мецима, баце у јаму, спале витриолом 
и покрију тешким каменим плочама, али вас не држаше ни гроб ни смрт, него сте прешли у истински Живот, за који од нас чујете овакве ствари:

Радујте се, сузе по лицу земље.
Радујте се , душе искушане.
Радујте се , јер сте у смрт знали да одлазите.
Радујте се , јер сте се мирно одвојили од осталих.
Радујте се , јер су вас одвели у мрачну шуму.
Радујте се , јер су ноге ваше оковане.
Радујте се , јер су развукли ужад око врата вашега.
Радујте се , јер су вас све напрасно побили.
Радујте се , јер се икона Народа расцепила.
Радујте се , јер кнезови из гробова устадоше.
Радујте се , јер растргана Хореја задрхта.
Радујте се , јер је распродати Тјудор био престрављен.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 4:

Уплашише се слуге сатанине ваше непоколебљивости и вере, светиње, и, намеравајући да вас униште, љутито кренуше на вас у тамницама: Римнику Сарат, Миеркурја Чук, Брашов и Васлуи (Râmnicu Sărat, Miercurea Ciuc, Braşov şi Vaslui), 
и у страшној „осветничкој ноћи“ 

мучеништвом овенчасте се певајићи Богу: Алилуја !

4. Икос:

Махинације безаконика вас, храбри Исповедници, ни на који начин нису ужаснуле, али схватајући да ћете погинути, у дворишту логора сви сте клекнули и у ноћној тишини смерно изговарали молитву „Оче наш“, затим су меци почели пљуштати на вас, док је један затворени свештеник тајно служио последњу службу за вас, и за оне који су погинули, за шта вас хвалимо говорећи :
Радујте се , јер сте са Христом умрли.
Радујте се , јер сте се народу на чисту жртву предали.
Радујте се , јер су се џелати чудили понашању вашем.
Радујте се , јер сте силном вером вашом победили.
Радујте се , јер су вас немилосрдни меци пожњели.
Радујте се , јер сте бол иза себе оставили.
Радујте се , јер су тела ваша на раскршћу путева постављена.
Радујте се , јер су вас без гробова и Крстова оставили.
Радујте се , они који су и после смрти били понижени.
Радујте се , они које су називали „издајницима земље”.
Радујте се , синови распетог народа.
Радујте се , јер сте кроз болове осветили душу своју.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 5:

Сам сатана је сишао да вас погуби, Свети исповедници, у страшној тамници Питешти, а ђавоимани џелат, унајмљен да сатре душе ваше, повика: „Да је Христос прошао кроз моје руке, не би стигао на крст и не би васкрсао“. Ја сам право јеванђеље! Пишем то сада на вашим лешевима!“; а ви, Светитељи, немајући наде на спасење осим од Бога, са сузама Му кличите: Алилуја!

5. Икос:

Анђели на небу сакрили су своја лица, не могавши да трпе безумље богомрзаца, јер су на Велики петак, у подсмеху, разапели младића на зиду и убили га дивљим ударцима, зидови тамнице тресли су се од вриске 

мучених и јаме су гутале гладне гомиле згњеченог меса и крви, али у дубинама пакла Бог ти даде моћ и силу, за шта те хвалимо говорећи :
Радујте се , мученици много пострадали.
Радујте се , јер вас звери у људском обличју ударише.
Радујте се , јер вас оштрим колцима бију по глави.
Радујте се , јер су ваши прсти клештима сломљени.
Радујте се , јер сте мржњом погажени.
Радујте се , јер сте јели на коленима, са везаним рукама.
Радујте се , јер сте со за храну примили.
Радујте се , јер сте данима без воде.
Радујте се , јер сте болове преко сваке мере подносили.
Радујте се , јер сте се великомученицима уподобљени (личили).
Радујте се , јер сте страшним телом пострадали.
Радујте се , јер је земља богатије душе уродила плодом.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 6:

Помахнитале убице из Ајудске тамнице мислиле су да ће о вама изгубити памћење, Светитељи, и бацише 
ваша много измучена тела у јаругу на „Робовском брду“, не знајући за силу Божију показану у визији 
пророка Језекиља који каже: "Рука Господња је била на мени и узео ме је у Духу и поставио ме усред 
долине пуне костију и рекао ми: „Сине човечји, могу ли ове кости оживети?“. Одговорио сам: 

"Господе, Боже, Ти то знаш!". 
Рекао ми је:
"Пророкуј о овим костима и реци им: Кости сухе, слушајте реч Господњу! Ево, увешћу Дух у вас и оживећете!". 
И Дух уђе у њих и они устадоше и стадоше. И беше као војска велика, по броју веома велика“, која је непрестано славила Бога, певајући Му: Алилуја !

6. Икос:

Затвор Ајуд је био молитвени дом, јер сте тамо проводили време у посту и бдењу, стекли сте трезвеност ума и 
смирење срца и научили сте Божанско Писмо, и ноћу клечећи са сузама молили сте се за мртве своје и за оне који су вас прогонили, за шта вас хвалимо говорећи:
Радујте се, Свете круноноше.

Радујте се , јер сте право подвижништво изабрали.
Радујте се , јер сте двоструку битку водили.
Радујте се , јер сте страсти у себи савладали.
Радујте се , јер сте се суочили и са џелатима.
Радујте се, јер су се заверили да вас униште.
Радујте се, јер сте ударце и пљување примили.
Радујте се, јер су вам удове у борби сатрли.
Радујте се, јер сте у замрзнутим ћелијама били.
Радујте се , јер су вас хладном водом полили.
Радујте се , јер сте све трпељиво поднео.
Радујте се , јер вас Сила одозго Учврсти.
Радујте се , Свети исповедници, који сте 
у Голготску тамницу румунског народа узашли!

Кондак 7:

Речи Спаситељеве: „брат ће брата погубити“ хтели су да испуне у тамници Герли, јер су вас демонски џелати с мржњом окретали један против другог, и дозивајући оца приморавали су га да згази своје дете, а он, павши на колена, повика: " Убијте ме, само не мучите мог дечака ! “; а ви, схватајући сотонино лудило, молили сте се говорећи: „Господе, дај нам снаге да издржимо или нам одузми животе", а Богу сте клицали: Алилуја !

7. Икос:

Људски ум не може да схвати суровост 

мука које сте поднели, Светитељи, јер сте били разапети по поду, бијени мокрим ужадима, прсти су вам гњечени клештима, 
и ударали су вас даскама по лицу да више нисте имали изглед људи, него сте, следећи Христа Распетог, све претрпли и џелатима опростили, за шта вас хвалимо говорећи:
Радујте се, тела сатрвена у мукама.
Радујте се , душе у Огњу просветљене.
Радујте се , јер је сатана тражио да вас пресеје.
Радујте се , јер сте веру имали као оружје.
Радујте се , јер сте претрпели до краја.
Радујте се , јер вам је Христос дао снагу.
Радујте се , јер сте после много страдања дошли до краја.
Радујте се , јер сте са просвећеним лицем умрли.
Радујте се , јер је снежно цвеће пало на ваш гроб.
Радујте се , јер су анђели невидљиво плакали за вама.
Радујте се , јер сте се на горе бола попели.
Радујте се , јер вас је Господ примио к Себи.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 8:

Јевреји који су били у ропству у Египту нису трпели ваша страдања, Свети исповедници, јер нисте се трудили да месите 
камење и цигле, него сте изнемоглим рукама померали планине земље са њихових места, и исклесали сте корито суза и крви, које све воде Дунава неће моћи да сперу, јер се 
непрестано диже глас ваше патње: Алилуја !

Икос 8:

Воде су дале глас и затресле се дубине страшног Канала, јер нема речи које се не чују и болова који не могу уродити плодом; а ми, Светитељи, чувши глас страсти ваших из дубине, овако вам говоримо:
Радујте се , душе крепке као древне планине.
Радујте се , дрвеће однешено олујама.
Радујте се , јер сте се по жеги и мразу трудили.
Радујте се , јер сте крвљу осветили земљу.
Радујте се , јер сте голи и гладни претрпели.
Радујте се , јер сте сузама у стени копали.
Радујте се , јер сте у зноју пут кроз камен исклесали.
Радујте се , јер сте добили ударце као плату.
Радујте се , јер сте се под таласима расули.
Радујте се , јер под обалом и песком почивате.
Радујте се , јер је изнемогло тело ваше сатрвено (смрвљрно).
Радујте се , јер је крепка душа донела плод.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 9:

Светлост је осванула у тамници страдалника из Таргу Окна (Târgu Ocna), 
јер сте као сунце засијали у њој, спокојни у души и у лицу, Свеци румунских тамница, утеху страдалника и похвалу убогих, 
који су у бдењу и молитви срца свога стекли дар Духа Светога, и унапред знајући крај свој, радосно се преселили ка Господу певајући: Алилуја!

Икос 9:

„Љубите оне који вас прогоне“, заповедио је Христос, и ви сте, Светитељи, тачно испунили реч Његову, јер је у Таргу Окни, 
у ноћи Рођења Господњег, један умирући свештеник замолио да га одведу код онога који га је страшно мучио, и, благо га тешећи, 
рекао је: "Опраштам вам свим срцем и верујем да ће вам и Христос, који је бољи од нас, опростити“. А онај се 
покајавши се са сузама исповеди, и у исту ноћ обојица у миру отидоше Господу, а ми, дивећи се сили љубави, хвалимо вас говорећи:

Радујте се, следбеници божанских заповести.
Радујте се, за небеском славом жудећи.
Радујте се, јер сте молитву Исусову примила.
Радујте се, јер вас је дар Духа Светога засенио.
Радујте се, јер вам је Јеванђеље водиља.
Радујте се, јер сте нашли просветљење и благодат.
Радујте се, јер је сунце међу вама засијало.
Радујте се, јер сте га „светитељем тамница“ назвала.
Радујте се, јер је из бола и муке израсло.
Радујте се, јер беше душа ваша као крин.
Радујте се, јер вас у непознати гроб бацише.
Радујте се, јер вас је небо снежним покровом обавило.
Радујте се, Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 10:

Непријатељи Христови хтели су не само да сатру тела и душе ваша, него и да се наругају правој вери, па су вас на Свете празнике Православља приморавали да чините хуле какве људски ум не може замислити, а ви, светитељи, трпећи понижења и муке, молили сте помоћ Божију, укрепљујући се: Алилуја!

Икос 10:

Радост Васкрсења заблистала је у мрачном руднику Баиа Сприе (Baia Sprie), када су у недрима земље свештеници затворени земљотресом повикали: „Дођи и упали светлост!“ , и звонасте бушилице почеше да звоне, светиљке се упалише и осуђеници, клечећи са сузама, певали су  „Христос Воскресе!“, чему вам се дивимо, хвалимо вас кличући:
Радујте се , живи сахрањени.
Радујте се , јер нисте хтели да се одрекнете Христа.
Радујте се , јер вам на руглу дадоше месо на Велики Петак.
Радујте се , јер трпећи глад, нисте јели.
Радујте се , јер сте у дубини Васкрсење прославили.
Радујте се , јер сте се постом и исповестима очистио.
Радујте се , јер сте Крст од греда 

подигли. 
Радујте се , јер су бушилице у облику звона зазвониле.
Радујте се , јер скупе собе нисте имали.
Радујте се , јер сте епитрахиљ од белог пешкира начинили.
Радујте се , јер сте са анђелима служили.
Радујте се , јер сте под земљом Христа исповедили.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 11:

Жестоки прогон који је на вас покренуто са гневом ,није поштедео ни слабу женску природу, и као и мученице давно, многе су жене смело исповедале љубав Христу и свом 

народу, и са радошћу подносиле муке, певајући Богу: Алилуја.

Икос 11:

Верници су се згрозили када су видели измучено тело жене доведено на спаљивање, а џелати каменог срца, не обазирући се на то 
да човек још има живота у себи, журно га бацише у пећ и пригушени (глухи) јауци одјекнуше из пламена, а ми, дрхтећи од оваквих ствари, са страхом говоримо:
Радујте се, крхка тела са отврднутим душама.
Радујте се , јер сте Христа смело исповедили.
Радујте се , јер сте постали као мученици у давнини.
Радујте се , јер сте многе муке претрпели.
Радујте се , јер сте поруге и батине примили.
Радујте се , јер су вас вешањем страшно намучили.
Радујте се , јер су вам прса дали на стрељање.
Радујте се , јер су руке војника задрхтале на оружју.
Радујте се , јер су вам тела до крви пребили.
Радујте се , јер вам душе не могоше дотаћи.
Радујте се , са Светима овога прогнаног народа.
Радујте се, сви који сте у вери помрли.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!


Кондак 12:


Божанска благодат вас је на диван начин засенила, светитељи, и у тамницама Питестија, Ајуда, Герле, Сигета, Баја Шприја, 
Таргу Окне и Канала (Piteşti, Aiud, Gherla, Sighet, Baia Sprie, Târgu Ocna şi Canal) , као мученици из давнина, претрпели 
сте многа страдања, и ви, знајући добро да је ово дело одозго, усрдније сте призивали Христа све више певајући: Алилуја!

Икос 12:

Ви сте овоземаљски живот сматрали ништавним и душе своје положили за праву веру и род праотаца свој, и сада се у 
пристаништу слободни од бола и туге радујете, са свима праведнима славећи Бога и слушајући од нас овако:

Радујте се , крила у лету пожњена.
Радујте се , обасјана лица благодати.
Радујте се , животи оковани.
Радујте се , јер вас свет мрзи.
Радујте се , зраци у тами запаљени.
Радујте се , руке до небеса раширене.
Радујте се , Свети без Крста и имена.
Радујте се , храмови са белим крунама.
Радујте се , реке са чистим водама.
Радујте се , гранчице натоварене плодовима.
Радујте се , гласници који донесте добре вести.
Радујте се , стене са гранитним тврђавама.
Радујте се , Свети исповедници, који сте у Голготску тамницу румунског народа узашли!

Кондак 13:

О Свети исповедници, ви који сте претрпели многа мучења у тамници и за Васкрсење румунског народа храбро сте мучеништво примили, смелост имајући Христа Бога нашега, молите се да се избавимо од сваке ђаволске обмане и да храбро исповедамо веру Православну, да спасавајући себе увек певамо Богу: Алилуја!

(Овај кондак певамо 3 пута, а затим Икос 1. па Кондак 1.)


 `

 const prviText =  `

 U gradu Ajuduje u vreme komunizma u Rumuniji bio jedan od zatvora u kojem su mučeni i stradali bogobojažljivi ljudi, sveštenici, monasi intelektualci, učitelji, doktori, pastiri. Jedan od načina mučenja je uz fizičko mučenje bilo i zatvaranje u duboke tamnice temperature 26 stepeni bez hrane i vode. Mošti mučenika mirotoče, na njima se vidi tkivo, krvni sudovi. U Ajuduje 17 godina bio zatočen starac Justin Parvu. Svete mošti novomučenika rumunskih postradalih u komunističkim zatvorime mirotočile su godinama. Čudo, čiji su svjedoci bile više stotina vjernih. Desilo su 19 marta 2009 godine u Jašiju. Miro je teklo toliko izobilno da se izlivalo iz kivota. Prva je zamirotočila lobanja jednog od mučenika čija je glava bila pretesterisana. Nakon nje, miro je poteklo i iz drugih moštiju. 

 Ajudski mučenici su i za života bili svedoci mnogo čuda, jer je Gospod nagrađivao njihovo stradanje, ljubav i brigu za bližnjeg. Oni su brinuli kako da preživi njihov sapatnik a nisu mislili na sebe.
U mestu Petru Voda, Neamt, Rumunija. `


export default function Akatist2() {
    return <div style={{whiteSpace: 'pre-wrap', textAlign: 'left', margin: 20}}>

    <Link to="/"> Nazad </Link> 
<div style={{display: "flex", justifyContent: 'center'}}>
<img src="ikona.jpg" alt="sv jefrem" />
</div>
<br></br>
<h3 style={{textAlign: 'center'}}>
AKATIST ЅVETIM AJUDSKIM MUČENICIMА KOMUNISTIČKIH ZATVORA

</h3>
{prviText}

<img src="slika.jpg" alt="sv jefrem" style={{marginTop: 30}}/>

{akatistText}

<img src="slika2.jpg" alt="sv jefrem" />

</div>        

}